import { useEffect, useState } from "react";
import useParamsInt from "../../hooks/UseParamsInt";
import { ShimmeredText } from "../common/Shimmered";
import { StackRow } from "../common/StackComponents";
import StandardForm from "../common/StandardForm";
import { useDismissMutation, useGetValidationResultQuery } from "./api";
import { LoadingOverLay } from "../common/LoadingOverLay";
import { Stack, IconButton, Separator, DefaultButton } from "@fluentui/react";
import { useHistory } from "react-router-dom";
import DismissModal from "./DismissModal";
import SaveButtonContainer from "../Dataset/SaveButtonContainer";
import CrudStatusDialogV2 from "../common/CrudStatusDialogV2";
import { getErrorMessage } from "../AccessPackages/utils";

export function EditDatasetValidation() {
    const id = useParamsInt("id") as number;

    const { data, isLoading, error, isError } = useGetValidationResultQuery(id, { skip: !id });
    const [dismiss, dismissResult] = useDismissMutation();
    const [errorMsg, setErrorMsg] = useState<string>();

    const history = useHistory();

    const [showDialog, setShowDialog] = useState(false);
    useEffect(() => {
        if (dismissResult.isSuccess || dismissResult.isError) {
            setShowDialog(true);
        }
    }, [dismissResult.isError, dismissResult.isSuccess]);

    useEffect(() => {
        if (error) {
            const strError = getErrorMessage(error);
            setErrorMsg(strError);
        } else {
            setErrorMsg(undefined);
        }
    }, [error]);

    useEffect(() => {
        if (dismissResult.error) {
            const strError = getErrorMessage(dismissResult.error);
            setErrorMsg(strError);
        } else {
            setErrorMsg(undefined);
        }
    }, [dismissResult.error]);

    const loading = isLoading && !isError;

    return (
        <>
            <CrudStatusDialogV2
                errorMsg={errorMsg}
                success={dismissResult.isSuccess}
                show={showDialog}
                message={"Updated Successfully"}
                onClose={() => setShowDialog(false)}
            />
            <LoadingOverLay isOverlayVisible={!!loading || dismissResult.isLoading} />
            <StandardForm widthPercent={50} mediumWidthPercent={90} smallWidthPercent={90}>
                <Stack.Item align="end" style={{ textAlign: "right" }}>
                    <IconButton
                        title="Close"
                        className="routing"
                        onClick={() => {
                            history.push("/dataCatalogValidations");
                        }}
                        iconProps={{ iconName: "Cancel" }}
                        allowDisabledFocus
                    />
                </Stack.Item>
                <StackRow columnWidth={40}>
                    <ShimmeredText loading={loading} txtLabel="Name">
                        {data?.name}
                    </ShimmeredText>

                    <ShimmeredText loading={loading} txtLabel="Endpoint">
                        <div style={{ overflow: "auto", whiteSpace: "nowrap", padding: "2px" }}>{data?.endpoint}</div>
                    </ShimmeredText>
                </StackRow>
                <StackRow columnWidth={40}>
                    <ShimmeredText loading={loading} txtLabel="Type">
                        {data?.type}
                    </ShimmeredText>
                    <ShimmeredText loading={loading} txtLabel="Message">
                        {data?.message}
                    </ShimmeredText>
                </StackRow>
                <StackRow columnWidth={40}>
                    <ShimmeredText loading={loading} txtLabel="Dismissed By">
                        <Stack>
                            <Stack.Item>{data?.dismissedBy}</Stack.Item>

                            <Stack.Item>
                                {data?.dismissedOn ? new Date(data?.dismissedOn).toLocaleString() : ""}
                            </Stack.Item>
                        </Stack>
                    </ShimmeredText>

                    <ShimmeredText loading={loading} txtLabel="Comment">
                        {data?.comment}
                    </ShimmeredText>
                </StackRow>
                <Separator />
                <SaveButtonContainer topPadding={0}>
                    <DismissModal dismiss={dismiss} id={id} />
                    <DefaultButton onClick={() => history.push("/dataCatalogValidations")} text="Cancel" />
                </SaveButtonContainer>
            </StandardForm>
        </>
    );
}
